
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import { AuthService, BrowseService, LabelLayoutService } from "@/services";
import { MODULE } from "@/config/modules";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { Browse } from "@/models/browse";
import { LabelLayoutModel } from "@/models/label-layout/label-layout-model";
import { BrowserInfo } from "@/utils/browser";
import AppLabelLayoutEditElectronProperties from "@/components/label-layout/LabelLayoutEditElectronProperties.vue";
import { ElectronFunctions } from "@/utils/electron/electron";
import { IElectronPrinter } from "@/utils/electron/electron-printer";

export default Vue.extend({
	data(){
		return {
			layouts: [] as LabelLayoutModel[],
			newLayoutModalOpen: false,
			browses: [] as Browse[],
			printerSettingsModalLayoutId: 0,
			printers: [] as IElectronPrinter[],
			coppying: false
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{to: "/settings", value: this.$ct("general")},
				{to: "/settings/label-layouts", value: this.$ct("label-layouts")},
			] as IBreadCrumb[];
		},
		labelModule():MODULE{
			return MODULE.ETIKETTEN;
		},
		hasModule():boolean {
			return AuthService.hasModule(this.labelModule);
		},
		locale():string{
			return this.$i18n.locale;
		},
		isElectron():boolean {
			return BrowserInfo.hasElectronConfigured();
		}
	},
	methods: {
		openNewLayoutModal(){
			this.newLayoutModalOpen = true;
		},
		getIconClassByBrowseId(browseId:number){
			return Browse.getIconClassByBrowseId(browseId);
		},
		editLayout(layout:LabelLayoutModel){
			this.$router.push(`/settings/label-layout/edit/${layout.ID}`);
		},
		async fetch(){
			let result = await LabelLayoutService.fetch();
			this.layouts = result.data;
		},
		async deleteLayout(layout:LabelLayoutModel){
			let message = this.$ct("are-you-sure-you-want-to-delete-layout", {name: layout.Name});
			let result = await this.$confirmBuilder(message).setWarningTitle().show();
			if (!result)return;
			await LabelLayoutService.deleteLayout(layout);
			await this.fetch();
		},
		editDefaultPrinter(layout:LabelLayoutModel){
			this.printerSettingsModalLayoutId = layout.ID;
		},
		async copyLayout(layout:LabelLayoutModel){
			if (this.coppying) return;
			this.coppying = true;
			try{

				let newLayout = new LabelLayoutModel(layout.getJSON());
				newLayout.ID = 0;
				newLayout.Name += " copy";
				let data = await LabelLayoutService.getById(layout.ID);
				newLayout.Data = data.Data;
				await LabelLayoutService.createLayout(newLayout);
				await this.fetch();
			}catch(err){

			}finally{
				this.coppying = false;
			}
		}
	},
	async created(){
		this.browses = await BrowseService.getBrowses();
		await this.fetch();
		if (BrowserInfo.hasElectronConfigured()){
			this.printers = await ElectronFunctions.getPrinters();
		}
	},
	components: {
		AppMissingModule,
		AppLabelLayoutEditElectronProperties
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
